import { render, staticRenderFns } from "./MenuCompany.vue?vue&type=template&id=0d0a6bfc&scoped=true"
import script from "./MenuCompany.vue?vue&type=script&lang=js"
export * from "./MenuCompany.vue?vue&type=script&lang=js"
import style0 from "./MenuCompany.vue?vue&type=style&index=0&id=0d0a6bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a6bfc",
  null
  
)

export default component.exports